import React from "react";
import { Divider, Skeleton, Stack, Typography } from "@mui/material";

import {
  useGetComments,
  usePostComment,
  usePutComment,
  useDeleteComment,
  usePostReaction,
} from "../../hooks/react-query/useCommentsData";

import CommentEditor from "./CommentEditor";
import CommentThread from "./CommentThread";

export const CommentSection = ({
  resourceType,
  resourceId,
  currentUserId,
  users = [],
}) => {
  const { data: comments, isLoading } = useGetComments(
    resourceType,
    resourceId,
  );
  const { mutate: postComment } = usePostComment(resourceType, resourceId);
  const { mutate: putComment } = usePutComment(resourceType, resourceId);
  const { mutate: deleteComment } = useDeleteComment(resourceType, resourceId);
  const { mutate: postReaction } = usePostReaction(resourceType, resourceId);

  const handleCreate = (body) => {
    postComment({ resourceType, resourceId, body });
  };

  const handleReply = (parentId, body) => {
    postComment({ resourceType, resourceId, parentId, body });
  };

  const handleEdit = (id, body) => {
    putComment({ id, body });
  };

  const handleDelete = (id) => {
    deleteComment(id);
  };

  const handleReaction = (id, emoji) => {
    postReaction({ id, emoji });
  };

  if (isLoading) {
    return (
      <Stack gap="12px" p="8px">
        {[1, 2, 3].map((i) => (
          <Stack key={i} gap="6px">
            <Stack direction="row" gap="8px" alignItems="center">
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton width={100} height={14} />
            </Stack>
            <Skeleton width="80%" height={14} />
          </Stack>
        ))}
      </Stack>
    );
  }

  return (
    <Stack gap="25px" p="4px">
      <CommentEditor
        users={users}
        onSubmit={handleCreate}
        placeholder="Write a comment..."
      />

      <Divider orientation="horizontal" flexItem />

      {!comments?.length && (
        <Typography
          variant="caption"
          fontSize={11}
          color="text.secondary"
          textAlign="center"
          py="12px"
        >
          No comments yet. Be the first to comment.
        </Typography>
      )}

      {comments?.map((comment) => (
        <CommentThread
          key={comment.id}
          comment={comment}
          currentUserId={currentUserId}
          users={users}
          onReply={handleReply}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onReaction={handleReaction}
        />
      ))}
    </Stack>
  );
};

export default CommentSection;
